import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientContext, TcsConfiguration } from 'src/app/app.config';
type EnvironmentKey = ClientContext['environment'];
const environmentDisplay: { [key in EnvironmentKey]: string } = {
  local: 'local',
  dev: 'development',
  prod: 'production',
  qa: 'QA',
  trn: 'training',
};
// eslint-disable-next-line no-var
declare var clientContext: any;
@Injectable({ providedIn: 'root' })
export class TcsConfigurationService {
  private readonly _context = new BehaviorSubject<ClientContext>(clientContext);

  get valueChanges(): Observable<TcsConfiguration> {
    return this._context.asObservable().pipe(map((c) => c.configuration));
  }

  get value(): TcsConfiguration {
    return this._context.getValue().configuration;
  }

  get environmentDisplay(): string {
    return environmentDisplay[this.environmentKey];
  }

  get environmentKey(): EnvironmentKey {
    return this._context.getValue().environment;
  }
}
